(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.dryper-size-guide');
    const root = document.getElementById('dryper-size-guide-tabs');
    if (!section || !root) return;

    const tabs = root.querySelectorAll('.dryper-size-guide__tab');
    const panels = root.querySelectorAll('.dryper-size-guide__panel');
    const bannerLinks = section.querySelectorAll('.dryper-size-guide__banner-link');

    function activateTab(target, scrollToTabs) {
      tabs.forEach((item) => {
        const isActive = item.dataset.tab === target;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      bannerLinks.forEach((link) => {
        link.classList.toggle('is-active', link.dataset.tab === target);
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.panel === target;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (scrollToTabs) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab.dataset.tab, false));
    });

    bannerLinks.forEach((link) => {
      link.addEventListener('click', () => activateTab(link.dataset.tab, true));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
